/** @flow */
import type { State } from "@store/reducers";
import type {
  EmployeeEventsState,
  DocumentType,
  ManualReferralTaskData,
  SpecificDocumentType,
} from "@modules/shared/reducer/employee-events/types";
import type { PaginationType } from "@types";

export const getEmployeeEvents = (state: State): EmployeeEventsState => state.shared.employeeEvents;

export const getDocuments = (state: State): Array<DocumentType> =>
  getEmployeeEvents(state).documents.content;

export const getDocumentsPagination = (state: State): PaginationType => {
  return state.shared.employeeEvents.documents.pagination;
};

export const getDocumentsTotalElements = (state: State): number => {
  return state.shared.employeeEvents.documents.totalElements;
};

export const getSpecificDocuments = (state: State): Array<SpecificDocumentType> =>
  ((((state || {}).shared || {}).employeeEvents || {}).specificDocuments || {}).content;

export const showRemoveDocumentModal = (state: State): boolean =>
  getEmployeeEvents(state).modals.removeDocument.visible;

export const getDocumentId = (state: State): number | null =>
  getEmployeeEvents(state).modals.removeDocument.documentId;

export const getDocumentName = (state: State): string | null =>
  getEmployeeEvents(state).modals.removeDocument.documentName;

export const getIsAddDocumentModalOpen = (state: State): boolean =>
  getEmployeeEvents(state).modals.addDocument.visible;

export const getEventHistoryList = (state: State): Object => {
  return state.shared.employeeEvents.eventHistory;
};

export const showMonitoringUpdateModal = (state: State): boolean =>
  getEmployeeEvents(state).modals.monitoringUpdate.visible;
export const showManualReferralModal = (state: State): boolean =>
  state.shared.employeeEvents.modals.manualReferral.visible;

export const getManualReferralProcesses = (state: State): Array<Object> =>
  state.shared.employeeEvents.modals.manualReferral.processes.content;

export const showHistoryItemModal = (state: State): boolean =>
  getEmployeeEvents(state).modals.eventHistoryItem.visible;

export const showAbsenceReviewModal = (state: State): boolean =>
  getEmployeeEvents(state).modals.absenceReviewItem.visible;
export const showReferralDecisionModal = (state: State): boolean =>
  state.shared.employeeEvents.modals.referralDecisionModal.visible;

export const showManualReferralTaskData = (state: State): boolean =>
  state.shared.employeeEvents.modals.manualReferralTaskDataModal.visible;

export const selectManualReferralTaskData = (state: State): ManualReferralTaskData =>
  state.shared.employeeEvents.modals.manualReferralTaskDataModal.taskData;

export const isManualReferralAvailable = (state: State): boolean =>
  state.shared.employeeEvents.isManualReferralAvailable;

export const isManualEmployeeEligible = (state: State): boolean =>
  state.shared.employeeEvents.isEmployeeEligible;
